/* eslint-disable @typescript-eslint/no-empty-function */
import { useState } from 'react';

export function useErrorObserver() {
  const [observer] = useState<any>(() => {
    return typeof window !== 'undefined'
      ? new MutationObserver(mutationsHandler)
      : { disconnect: () => {}, observe: () => {} };
  });

  return { disconnect, observe };

  function disconnect() {
    observer.disconnect();
  }

  function observe(target: HTMLElement) {
    return observer.observe(target, {
      attributes: true,
    });
  }

  function mutationsHandler(
    ...args: Parameters<MutationCallback>
  ): ReturnType<MutationCallback> {
    const [mutations] = args;

    mutations
      .filter((m) => m.type === 'attributes' && m.attributeName === 'class')
      .forEach((m) => {
        const target = m.target as HTMLInputElement;
        const field = target.closest('.field');

        if (target.classList.contains('error')) {
          field?.classList.add('error');
        } else {
          field?.classList.remove('error');
        }
      });
  }
}

export function moveRequiredAsterisk(el: any) {
  if (!el.querySelector('.hs-form-required')) return;

  const p = el.querySelector("span[data-reactid^='.hbspt-forms'] > p");

  if (!p) return;

  p.innerHTML = `${p.innerHTML}*`;
}
